import React from 'react';
import classnames from 'classnames';

export default ({ className, indent, children }) => <div className={classnames('holder', className, indent)}>{children}</div>
